import { compose } from 'redux';
import { connect } from 'react-redux';
import DazeModelScrollView from '../../../daze/pages/modelScroll/DazeModelScrollView';
import selectors from '../../../rootSelectors';
import { setMazeScreenMode } from '../../mazeActions';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { stopAudio } from '../../../common/audio/audioActions';
import {
    blockScreen, unblockScreen, unmountScreen, activateNextButton,
} from '../../../common/screen/screenActions';
import { goToCountdown } from '../../../common/navigation/navigationActions';
import { SCROLL, MODE } from '../../../constants/assessmentItemType';
import { highlightCorrectResponses } from '../modelScroll/MazeModelScrollActions';
import { narrateReadyScript }
    from './MazeInstructionsActions';
import { NO_SCROLL_ANIMATION_DURATION } from '../../../constants/slider';

const mapStateToProps = (state, ownProps) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDataFetched: selectors.getIsMazeDataFetched(state),
    isDownButtonHighlighted: selectors.getIsDownButtonHighlighted(state),
    isScrollButtonClicked: selectors.getIsScrollButtonClicked(state),
    isOkButtonGreyedOut: selectors.getIsOkButtonGreyedOut(state),
    paragraphs: selectors.getMazeParagraphs(state, SCROLL),
    questions: selectors.getMazeQuestionItems(state, SCROLL),
    title: selectors.getMazeTitle(state, SCROLL),
    selectedResponses: selectors.getMazeSelectedResponses(state),
    screenMode: selectors.getMazeScreenMode(state),
    scrollDuration: NO_SCROLL_ANIMATION_DURATION,
    isExtendedView: ownProps.isExtendedView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchContent: () => {
        dispatch(ownProps.flowStrategy.fetchContent());
        dispatch(setMazeScreenMode(MODE.READY));
    },
    initModelScrollScreen: () => {
        dispatch(highlightCorrectResponses());
    },
    readyScript: () => {
        dispatch(blockScreen());
        dispatch(activateNextButton());
        return dispatch(narrateReadyScript(ownProps.flowStrategy.instructions[SCROLL]))
            .then(() => {
                dispatch(unblockScreen());
            });
    },
    onNext: () => {
        dispatch(goToCountdown(ownProps.flowStrategy.assessment));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(unmountScreen());
    },
});


// memorize instructions array to prevent re-rendering
let instructions;
const getInstructions = (scrollInstructions) => {
    if (instructions === undefined) {
        instructions = [
            scrollInstructions.scrollInstruction,
            scrollInstructions.scrollReadyClickOk,
        ];
    }
    return instructions;
};

const avatarMapStateToProps = (_, ownProps) => {
    return {
        position: ownProps.isExtendedView ? AvatarView.Position.LOWER_FAR_LEFT : AvatarView.Position.MIDDLE_LEFT,
        instructions: getInstructions(ownProps.flowStrategy.instructions[SCROLL]),
    };
};

const MazeInstructionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(DazeModelScrollView);

export default MazeInstructionsContainer;
